import * as React from 'react';
import {EmailConfirmedScreenType} from '@practicegenius/register-account/src/screens/EmailConfirmed';
import {ProgressScreen} from '../../../components/screens/BaseScreen';
import {SvgImage} from '../../../components/SvgImage/SvgImage';
import {CenteredWrapper} from '../../../components/screens/layout';

export const EmailConfirmed: EmailConfirmedScreenType = ({
  lang,
  progress,
  actionButtons,
  title,
  instructions,
}) => (
  <ProgressScreen
    helmetTitle={lang.pageTitle}
    headerTitle={lang.headerTitle}
    progress={progress}
    title={title}
    instructions={instructions}
    actionButtons={[actionButtons.primary]}
    cancelProps={{href: '/'}}
  >
    <CenteredWrapper>
      <SvgImage name="emailVerified" />
    </CenteredWrapper>
  </ProgressScreen>
);
